module.exports = __webpack_public_path__ + "img/index-banner-pc.a11e15de.jpg";